function createKeyPressHandlers(handler, keyCode, ...keys) {
    return (event)=>{
        // keyCode and which are deprecated, we have it for legacy reason
        if (keys.includes(event.key) || event.keyCode === keyCode || event.which === keyCode) {
            handler(event);
        }
    };
}
function emulateClick(elementRef) {
    if (elementRef && elementRef.current && typeof elementRef.current.click === 'function') {
        // elementRef.current.click()
        elementRef.current.dispatchEvent(new Event('click'));
    }
}
function createClickOnEnterHandler(elementRef) {
    return createKeyPressHandlers(()=>emulateClick(elementRef), 13, 'Enter');
}
function createClickOnSpaceHandler(elementRef) {
    return createKeyPressHandlers(()=>emulateClick(elementRef), 32, ' ', 'Spacebar');
}

export { createClickOnEnterHandler, createClickOnSpaceHandler, createKeyPressHandlers };
